export const de = {
  toolCategory: {
    project: "Projekt",
    accounting: "Buchhaltung",
    conversation: "Ticket",
    customer: "Organisation",
    general: "Allgemein",
    order: "Bestellung",
    server: "Server",
    user: "User",
    dev: "Dev",
  } as Record<string, string>,
  relativeDateTime: {
    justNow: "gerade eben",
    yesterday: "gestern",
    dayBeforeYesterday: "vorgestern",
  },
  customer: {
    role: {
      accountant: "Organisationsbuchhalter",
      notset: "Keine Rolle",
      owner: "Organisationsinhaber",
      member: "Organisationsmitglied",
    },
  },
  project: {
    role: {
      emailadmin: "E-Mail-Administrator",
      notset: "Keine Rolle",
      owner: "Projektadministrator",
      external: "Projektentwickler",
    },
  },
  conversation: {
    category: {
      apps: "Apps",
      articles: "Vertragspositionen",
      backups: "Backups",
      contractOwner: "Vertragspartner",
      cronjobs: "Cronjobs",
      databases: "Datenbanken",
      domains: "Domains",
      emails: "E-Mails",
      general: "Allgemein",
      invoices: "Rechnungen",
      payment: "Zahlungsmodalitäten",
      ssh: "SSH/SFTP",
      workload: "Auslastungen",
      extension: "Extension",
      containers: "Container",
    },
  },
  app: {
    description: {
      Contao: "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Drupal Core": "",
      Grav: "",
      HumHub: "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Joomla!": "",
      Magento: "",
      Matomo: "",
      Moodle: "",
      NEOS: "",
      Nextcloud: "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Node.js": "",
      PHP: "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "PHP-Worker": "",
      PrestaShop: "",
      Python: "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Shopware 5": "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Shopware 6": "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "Static Files": "",
      TYPO3: "",
      WordPress: "",
    },
  },
  invoice: {
    status: {
      CANCELED: "Storniert",
      CONFIRMED: "Bestätigt",
      NEW: "Neu",
      PAID: "Bezahlt",
      PARTIALLY_PAID: "Teilweise bezahlt",
    },
  },
  invoiceSettings: {
    invoicePeriod: {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      1: "Monatlich",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      3: "alle 3 Monate",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      6: "alle 6 Monate",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      12: "Jährlich",
    },
    paymentMethod: {
      debit: "Lastschrift",
      invoice: "Rechnung",
    },
  },
  systemSoftware: {
    description: {
      composer: "",
      gs: "",
      gm: "",
      im: "",
      mc: "",
      mysql: "",
      nano: "",
      node: "",
      pdftools: "",
      perl: "",
      php: "",
      python: "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "redis-cli": "",
      webp: "",
      // eslint-disable-next-line @typescript-eslint/naming-convention
      "wp-cli": "",
    },
  },
  user: {
    title: {
      mr: "Herr",
      ms: "Frau",
    },
  },
  aggregate: {
    server: "Server",
    customer: "Organisation",
    project: "Projekt",
    appInstallation: "App",
    extensionInstance: "Extension",
    user: "Benutzer",
    backup: "Backup",
    customerInvite: "Organisationseinladung",
    projectInvite: "Projekteinladung",
    mailAddress: "E-Mail-Adresse",
    domain: "Domain",
    certificate: "SSL-Zertifikat",
    ingress: "Domain",
    conversation: "Ticket",
    order: "Bestellung",
    invoice: "Rechnung",
    registry: "Registry",
    wallet: "Weiterempfehlung",
    finderProfile: "LeadFyndr",
    finderProfileRequest: "LeadFyndr",
  },
};

export type Translations = typeof de;
